import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import {
  IMessageResponseDto,
  ISendTgCustomMessageDto,
  ISettingsRespDto,
  ISettingsSignupRespDto,
  IUpdateDescriptionEntityPayloadDto,
  IUpdateModelsPayloadDto,
  IUpdateSettingsImagesPayloadDto,
  IUpdateSettingsSignupDto,
  IUpdateSettingsSwitchDto,
  IUpdateListDto,
  IUpdateTgSendMessagePermissionsDto,
  IUpdateToolsPayloadDto,
  IUpdateTraicyDefinitionDto,
  IUpdateTraicyHashtagsListDto,
  IUpdateTraicyPostsPayloadDto,
  IUpdateSettingFieldsDto,
} from 'src/types'

class SettingsService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getSettings() {
    return this.get<ISettingsRespDto>('settings')
  }

  getCommonSettings() {
    return this.get<ISettingsRespDto>('settings/common')
  }

  getSignupSettings() {
    return this.get<ISettingsSignupRespDto>(`settings/register`)
  }

  updateSignUp(dto: IUpdateSettingsSignupDto) {
    return this.put<IMessageResponseDto, IUpdateSettingsSignupDto>(`settings/register`, dto)
  }

  allowScanToErnSetting(dto: IUpdateSettingsSwitchDto) {
    return this.put<IMessageResponseDto, IUpdateSettingsSwitchDto>(`settings/scan-to-earn`, dto)
  }

  updateShowJourneyHomePage(dto: IUpdateSettingsSwitchDto) {
    return this.put<IMessageResponseDto, IUpdateSettingsSwitchDto>(
      `settings/journey-home-page`,
      dto,
    )
  }

  updateTraicyDefinition(dto: IUpdateTraicyDefinitionDto) {
    return this.put<IMessageResponseDto, IUpdateTraicyDefinitionDto>(
      `settings/traicy-definition`,
      dto,
    )
  }

  updateList(dto: IUpdateListDto) {
    return this.put<IMessageResponseDto, IUpdateListDto>(`settings/tg-chat-ids`, dto)
  }

  updateTgSendMsgPermissions(dto: IUpdateTgSendMessagePermissionsDto) {
    return this.put<IMessageResponseDto, IUpdateTgSendMessagePermissionsDto>(
      `settings/tg-send-permissions`,
      dto,
    )
  }

  updateTraicyPostsPayload(dto: IUpdateTraicyPostsPayloadDto) {
    return this.put<IMessageResponseDto, IUpdateTraicyPostsPayloadDto>(`settings/traicy-posts`, dto)
  }

  updateSettingFields(dto: IUpdateSettingFieldsDto) {
    return this.put<IMessageResponseDto, IUpdateSettingFieldsDto>(`settings/fields`, dto)
  }

  sendTgCustomMessage(dto: ISendTgCustomMessageDto) {
    return this.post<IMessageResponseDto, ISendTgCustomMessageDto>(`telegram/tg-send-message`, dto)
  }

  updateModelsPayload(dto: IUpdateModelsPayloadDto) {
    return this.put<IMessageResponseDto, IUpdateModelsPayloadDto>(`settings/models`, dto)
  }

  updateToolsPayload(dto: IUpdateToolsPayloadDto) {
    return this.put<IMessageResponseDto, IUpdateToolsPayloadDto>(`settings/tools`, dto)
  }

  updateDescriptionEntityPayload(dto: IUpdateDescriptionEntityPayloadDto) {
    return this.put<IMessageResponseDto, IUpdateDescriptionEntityPayloadDto>(
      `settings/description-entity`,
      dto,
    )
  }

  updateImagesPayload(dto: IUpdateSettingsImagesPayloadDto) {
    return this.put<IMessageResponseDto, IUpdateSettingsImagesPayloadDto>(`settings/images`, dto)
  }

  updateTraicyHashtagsList(dto: IUpdateTraicyHashtagsListDto) {
    return this.put<IMessageResponseDto, IUpdateTraicyHashtagsListDto>(
      `settings/traicy-hashtags`,
      dto,
    )
  }

  checkMatickBalance() {
    return this.get<{
      lowBalanceStatus: boolean
      balance: number
    }>(`settings/balance-threshold`)
  }
}

export const settingsService = new SettingsService()
export default SettingsService
